import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import Button from '@swf/components/StarsButton/StarsButton';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import Translation from '@swf/components/Translation/Translation';
import { ResolverTag } from '@swf/core/enums';
import type { InjectedResolverProps } from '@swf/core/hoc/withResolver';
import withResolver from '@swf/core/hoc/withResolver';
import type { Dispatch } from '@swf/core/store';
import { externalLink } from '@swf/core/utils';

import {
  TXTCLI_Login_information,
  TXTCLI_OK,
  TXTWCL_Should_you_wish_to_contact_usX_ELL,
  TXTWCL_These_checks_are_usually_compl_ELL,
  TXTWCL_Your_account_has_been_temporar_ELL_1
} from './SecurityInvestigation.messages.json';
import styles from './SecurityInvestigation.scss';

type DispatchProps = ReturnType<typeof mapDispatch>;
type Props = DispatchProps & InjectedResolverProps;

const SecurityInvestigation: React.FC<Props> = ({ resolverTags, close }) => (
  <>
    <Header>
      <Translation {...TXTCLI_Login_information} />
      <CloseButton />
    </Header>
    <Body>
      <p className={styles.message}>
        <Translation {...TXTWCL_Your_account_has_been_temporar_ELL_1} />
      </p>
      <p className={styles.message}>
        <Translation {...TXTWCL_These_checks_are_usually_compl_ELL} />
      </p>
      <p className={styles.message}>
        <Translation
          {...TXTWCL_Should_you_wish_to_contact_usX_ELL}
          values={{
            a: externalLink(resolverTags.realmoneySecurityFaq)
          }}
        />
      </p>
      <ButtonGroup>
        <Button block onClick={() => close()} translation={TXTCLI_OK} />
      </ButtonGroup>
    </Body>
  </>
);

const mapDispatch = ({ modal: { close } }: Dispatch) => ({ close });
export default compose(
  // @ts-ignore https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31363
  connect<null, DispatchProps>(null, mapDispatch),
  withResolver([ResolverTag.RealMoneySecurityFaq])
  // @ts-ignore https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31363
)(SecurityInvestigation) as ComponentType;
